import { gap } from '@ui/theme/values'
import { useSelectIntroDeal } from '@order/hooks/useDealTypeModal'
import React from 'react'
import { View } from 'react-native'

import useDealsByTags from '@order/hooks/useDealsByTags'
import { PendingOrder } from 'hooks/useSession'
import DealList from './DealList'
import { useBaseDealPackagePrice } from './useBaseDealPackagePrice'
import { useCardFilter } from './useCardFilter'

export default function DealsExtra({ pending }: { pending: PendingOrder }) {
  const dealFilter = pending.deal.filter

  const filter = useCardFilter({
    initial: {
      tag: dealFilter?.tag,
      type: dealFilter?.type,
      tags_excluded: dealFilter?.tagsExcluded?.join(','),
      price: dealFilter?.price,
    },
  })

  const filterTag = filter.tag
  const baseDealPrice = useBaseDealPackagePrice()

  const deals = useDealsByTags({
    hidden: !!filterTag,
    filterCards: true,
    types: filter.type ? [filter.type] : undefined,
    tagsExcluded: filter.tagsExcluded,
    price: filter.price,
    baseDealPrice,
  })

  const dealsFiltered = filterTag ? deals.byTags[filterTag] ?? [] : deals.all

  const selectIntroDeal = useSelectIntroDeal({
    type: pending.type,
  })

  return (
    <>
      <View
        className="flex w-full flex-row flex-wrap justify-between"
        style={{
          gap,
          paddingHorizontal: gap,
          paddingTop: gap,
          paddingBottom: gap,
        }}
      >
        <DealList onSelect={selectIntroDeal} deals={dealsFiltered} />
      </View>
    </>
  )
}
